import { render, staticRenderFns } from "./DemoTreeviewSearchAndFilter.vue?vue&type=template&id=34b8a640&"
import script from "./DemoTreeviewSearchAndFilter.vue?vue&type=script&lang=js&"
export * from "./DemoTreeviewSearchAndFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VIcon,VTextField,VTreeview})
